import React, { useEffect } from 'react';
import { tracker } from '@fiverr-private/listing_lib';
import { EmptySearchResults } from '@fiverr-private/listing_results';

export const ErrorPage = ({ currency }) => {
    useEffect(() => {
        tracker.error();
    }, []);

    return <EmptySearchResults currency={currency} />;
};
